import { ZONES, works } from "./data";

// Horizontal half-extent (world units) of the content in each zone. The camera
// rig uses this to decide how far to dolly back on narrow screens and how far
// the visitor may pan sideways.
const FIXED_HALF_W = {
  hall: 13.6,
  skills: 10,
  archive: 17.8,
  resume: 5.5,
  library: 14,
  contact: 8.8,
};

// X offsets for n projects, centred, 8 units apart (n = 4 gives -12, -4, 4, 12).
export function workXs(n = works.length) {
  return Array.from({ length: n }, (_, i) => (i - (n - 1) / 2) * 8);
}

export function zoneHalfW(id) {
  if (id === "works") return Math.max(15, ((works.length - 1) / 2) * 8 + 3.5);
  return FIXED_HALF_W[id] ?? 12;
}

export function workFocus(i) {
  const gx = ZONES[1].pos[0];
  const lx = workXs()[i] ?? 0;
  return {
    pos: [gx + lx * 0.55, 3.4, 9.5],
    look: [gx + lx, 2.4, 0],
    fit: 4.4,
  };
}

// How many world units either side of centre we want visible for a given
// viewport aspect ratio. Phones in portrait see a narrower slice (and pan);
// landscape screens see the whole composition.
export function desiredHalfWidth(aspect) {
  const t = Math.min(1, Math.max(0, (aspect - 0.46) / (1.33 - 0.46)));
  return 7.8 + 6.2 * t;
}
